import request from "@/http";
const getOfferData = (data) => {
  let { pre_db_para_order_by_para,id_public_user_info,mid_table_remark_004,mid_table_remark_005,mid_table_remark_007,mid_table_remark_013,is_online, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_middle_table_name: "public_middle_table_little_mode",
      pre_db_para_begin_idx: 0,
      pre_db_para_length_4_list: 10,
      type_middle_app: 10001,
      type_inner_app: 3003,
      is_online_in: is_online ? is_online : 0,
      mid_table_remark_004:mid_table_remark_004,
      mid_table_remark_005_like:mid_table_remark_005,
      mid_table_remark_007_in:mid_table_remark_007,
      mid_table_remark_013_in:mid_table_remark_013,
      id_public_user_info:id_public_user_info,
      pre_db_para_order_by_para: pre_db_para_order_by_para?pre_db_para_order_by_para:' mid_table_remark_006 asc ',
    },
    loading: {
      enabled: isloading
    }
  })
}
const insertOfferData = (data) => {
  let { pre_db_para_mid_table_remark_004,is_online,mid_table_remark_001,mid_table_remark_002,mid_table_remark_003,mid_table_remark_004,mid_table_remark_005,mid_table_remark_006,mid_table_remark_007,mid_table_remark_008,mid_table_remark_009,mid_table_remark_010,mid_table_remark_011,mid_table_remark_013,mid_table_remark_014,mid_table_remark_015,mid_table_remark_016,time_4_begin,id_public_middle_table,id_public_user_info, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_insert_or_update_middle_table",
      pre_db_para_id_public_middle_table: id_public_middle_table,
      pre_db_para_mid_table_remark_004: pre_db_para_mid_table_remark_004,
      id_public_user_info: id_public_user_info,
      mid_table_remark_001: mid_table_remark_001,
      mid_table_remark_002: mid_table_remark_002,
      mid_table_remark_003: mid_table_remark_003,
      mid_table_remark_004: mid_table_remark_004,
      mid_table_remark_005: mid_table_remark_005,
      mid_table_remark_006: mid_table_remark_006,
      mid_table_remark_007: mid_table_remark_007,
      mid_table_remark_008: mid_table_remark_008,
      mid_table_remark_009: mid_table_remark_009,
      mid_table_remark_010: mid_table_remark_010,
      mid_table_remark_011: mid_table_remark_011,
      mid_table_remark_013: mid_table_remark_013,
      mid_table_remark_014: mid_table_remark_014,
      mid_table_remark_015: mid_table_remark_015,
      mid_table_remark_016: mid_table_remark_016,
      time_4_begin: time_4_begin,
      pre_db_para_middle_table_name: "public_middle_table_little_mode",
      type_middle_app: 10001,
      type_inner_app: 3003,
      is_online: is_online ? is_online : 0,
    },
    loading: {
      enabled: isloading
    }
  })
}
const updateOfferData = (data) => {
  let { pre_db_para_mid_table_remark_004,pre_db_para_is_online,is_online,mid_table_remark_001,mid_table_remark_002,mid_table_remark_003,mid_table_remark_004,mid_table_remark_005,mid_table_remark_006,mid_table_remark_007,mid_table_remark_008,mid_table_remark_009,mid_table_remark_010,mid_table_remark_011,mid_table_remark_013,mid_table_remark_014,mid_table_remark_015,mid_table_remark_016,time_4_begin,id_public_middle_table,id_public_user_info, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_insert_or_update_middle_table",
      pre_db_para_id_public_middle_table: id_public_middle_table,
      pre_db_para_type_middle_app: 10001,
      pre_db_para_type_inner_app: 3003,
      pre_db_para_is_online: pre_db_para_is_online,
      pre_db_para_mid_table_remark_004: pre_db_para_mid_table_remark_004,
      id_public_user_info: id_public_user_info,
      mid_table_remark_001: mid_table_remark_001,
      mid_table_remark_002: mid_table_remark_002,
      mid_table_remark_003: mid_table_remark_003,
      mid_table_remark_004: mid_table_remark_004,
      mid_table_remark_005: mid_table_remark_005,
      mid_table_remark_006: mid_table_remark_006,
      mid_table_remark_007: mid_table_remark_007,
      mid_table_remark_008: mid_table_remark_008,
      mid_table_remark_009: mid_table_remark_009,
      mid_table_remark_010: mid_table_remark_010,
      mid_table_remark_011: mid_table_remark_011,
      mid_table_remark_013: mid_table_remark_013,
      mid_table_remark_014: mid_table_remark_014,
      mid_table_remark_015: mid_table_remark_015,
      mid_table_remark_016: mid_table_remark_016,
      time_4_begin: time_4_begin,
      pre_db_para_middle_table_name: "public_middle_table_little_mode",
      is_online: is_online ? is_online : 0,
    },
    loading: {
      enabled: isloading
    }
  })
}
const getTaskData = (data) => {
  let { begin_idx, limit, id_public_middle_table, pre_db_para_order_by_para, is_online, mid_table_remark_001, mid_table_remark_013, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_middle_table_name: "public_middle_table_little_mode",
      pre_db_para_order_by_para: pre_db_para_order_by_para ? pre_db_para_order_by_para : 'id_public_middle_table desc',
      pre_db_para_begin_idx: begin_idx,
      pre_db_para_length_4_list: limit,
      type_middle_app: 2222,
      type_inner_app: 4004,
      id_public_middle_table: id_public_middle_table,
      is_online_in: is_online ? is_online : 0,
      mid_table_remark_001_like: mid_table_remark_001,
      mid_table_remark_013_in: mid_table_remark_013?mid_table_remark_013:'1301'
    },
    loading: {
      enabled: isloading
    }
  })
}
const getAllTaskData = (data) => {
  let { id_public_middle_table, is_online, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_middle_table_name: "public_middle_table_little_mode",
      pre_db_para_order_by_para: ' id_public_middle_table desc ',
      id_public_middle_table: id_public_middle_table,
      pre_db_para_begin_idx: 0,
      pre_db_para_length_4_list: 1000,
      type_middle_app: 2222,
      type_inner_app: 4004,
      is_online_in: is_online ? is_online : 0,
    },
    loading: {
      enabled: isloading
    }
  })
}

const getApplyInfo = (data) => {
  let { mid_table_remark_002, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_middle_table_name: "public_middle_table",
      mid_table_remark_002: mid_table_remark_002,
      pre_db_para_begin_idx: 0,
      pre_db_para_length_4_list: 10,
      type_middle_app: 65001,
      type_inner_app: 20002,
      is_online_in: 0,
    },
    loading: {
      enabled: isloading
    }
  })
}

const insertTaskData = (data) => {
  let { mid_table_remark_013,id_public_middle_table, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_insert_or_update_middle_table",
      pre_db_para_middle_table_name: "public_middle_table_little_mode",
      pre_db_para_id_public_middle_table: id_public_middle_table,
      mid_table_remark_013: mid_table_remark_013,
      type_middle_app: 2222,
      type_inner_app: 4004,
      is_online: 0
    },
    loading: {
      enabled: isloading
    }
  })
}
export default {
  getOfferData,
  insertOfferData,
  getTaskData,
  getAllTaskData,
  insertTaskData,
  updateOfferData,
  getApplyInfo
}
